import { render, staticRenderFns } from "./contactus.vue?vue&type=template&id=6cb20480&"
import script from "./contactus.vue?vue&type=script&lang=js&"
export * from "./contactus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports